import Apollo from '@/graphql/vue-apollo'

import gql from 'graphql-tag'

const DELETE_CANDIDATE_PROFILE_TRANSLATION = gql`
  mutation DeleteandidateProfileTranslation($input: DeleteCandidateProfileTranslationInput!, $countryLanguage: CountryLanguage) {
    deleteCandidateProfileTranslation(input: $input) {
      user {
        id
        profile {
          id
          ... on CandidateProfileGraphType {
            city
            country(language: $countryLanguage) {
              id
              countryCode
              name
            }
            nationalities(language: $countryLanguage) {
              id
              countryCode
              name
            }
            domains
            experienceLevel
            firstName
            hasCsq
            languages {
              id
              language
              level
            }
            lastName
            linkedInProfile
            phoneNumber
            cellphoneNumber
            picture
            birthdate
            educationLevel
            overallAverage
            lastYearAverage
            ratingSystem
            currentlySubscribedToStudyProgram
            hasReportsAndDiplomasCopy
            currentStudyProgramLevel
            frenchLanguageTestPassed
            trainingLevel
            hasFirstStudyYearLivingExpensesFinancialResources
            tuitionFeesAbleToPay
            livingExpensesPayer
            studyExpensesPayer
            financialResourcesProofs
            trainingRelated
            willComeToCanadaWithFamilyMember
            isInterestedInPartTimeJob
            isInterestedInJobAfterGraduating
            homeCountryJobProspects
            translations {
              id
              competencies
              education {
                id
                details
                domain
                graduationDate
                level
                schoolName
                startDate
              }
              experience {
                id
                companyName
                endDate
                jobTitle
                location
                responsibilities
                startDate
              }
              immigrationProject
              language
              links {
                id
                description
                link
                title
              }
              personalDescription
              livingExpensesPayerOtherSpecification
              studyExpensesPayerOtherSpecification
              willComeToCanadaWithFamilyMemberSpecification
              dreamJobDescription
            }
          }
        }
      }
    }
  }
`
const UPDATE_CANDIDATE_PROFILE_TRANSLATION = gql`
  mutation UpdateCandidateProfileTranslation($input: UpdateCandidateProfileTranslationInput!, $countryLanguage: CountryLanguage) {
    updateCandidateProfileTranslation(input: $input) {
      user {
        id
        profile {
          id
          ... on CandidateProfileGraphType {
            city
            country(language: $countryLanguage) {
              id
              countryCode
              name
            }
            nationalities(language: $countryLanguage) {
              id
              countryCode
              name
            }
            domains
            experienceLevel
            firstName
            hasCsq
            languages {
              id
              language
              level
            }
            lastName
            linkedInProfile
            phoneNumber
            cellphoneNumber
            picture
            birthdate
            educationLevel
            overallAverage
            lastYearAverage
            ratingSystem
            currentlySubscribedToStudyProgram
            hasReportsAndDiplomasCopy
            currentStudyProgramLevel
            frenchLanguageTestPassed
            trainingLevel
            hasFirstStudyYearLivingExpensesFinancialResources
            tuitionFeesAbleToPay
            livingExpensesPayer
            studyExpensesPayer
            financialResourcesProofs
            trainingRelated
            willComeToCanadaWithFamilyMember
            isInterestedInPartTimeJob
            isInterestedInJobAfterGraduating
            homeCountryJobProspects
            translations {
              id
              competencies
              education {
                id
                details
                domain
                graduationDate
                level
                schoolName
                startDate
              }
              experience {
                id
                companyName
                endDate
                jobTitle
                location
                responsibilities
                startDate
              }
              immigrationProject
              language
              links {
                id
                description
                link
                title
              }
              personalDescriptionPro
              personalDescriptionStudent
              visaRefusedReason
              livingExpensesPayerOtherSpecification
              studyExpensesPayerOtherSpecification
              willComeToCanadaWithFamilyMemberSpecification
              dreamJobDescription
            }
          }
        }
      }
    }
  }
`
const UPDATE_CANDIDATE_PROFILE = gql`
  mutation UpdateCandidateProfile($input: UpdateCandidateProfileInput!, $countryLanguage: CountryLanguage) {
    updateCandidateProfile(input: $input) {
      candidate {
        id
        profile {
          id
          ... on CandidateProfileGraphType {
            city
            country(language: $countryLanguage) {
              id
              countryCode
              name
            }
            domains
            experienceLevel
            firstName
            hasCsq
            hasPassport
            hasTraveled
            hasTraveledToCanada
            hasCanFam
            hasVisaRefused
            hasInfraction
            hasEntryRefused
            visaRefusedType
            languages {
              id
              language
              level
            }
            lastName
            linkedInProfile
            phoneNumber
            cellphoneNumber
            picture
            birthdate
            educationLevel
            overallAverage
            lastYearAverage
            ratingSystem
            currentlySubscribedToStudyProgram
            hasReportsAndDiplomasCopy
            currentStudyProgramLevel
            frenchLanguageTestPassed
            trainingLevel
            hasFirstStudyYearLivingExpensesFinancialResources
            tuitionFeesAbleToPay
            livingExpensesPayer
            studyExpensesPayer
            financialResourcesProofs
            trainingRelated
            willComeToCanadaWithFamilyMember
            isInterestedInPartTimeJob
            isInterestedInJobAfterGraduating
            homeCountryJobProspects
          }
        }
      }
    }
  }
`
const DELETE_CANDIDATE = gql`
  mutation DeleteCandidateAccount($input: DeleteCandidateAccountInput!) {
    deleteCandidateAccount(input: $input)
  }
`

export default {
  deleteCandidate: async function(candidateProfileId) {
    const input = { candidateProfileId }

    await Apollo.instance.defaultClient.mutate({
      mutation: DELETE_CANDIDATE,
      variables: {
        input
      }
    })
  },
  updateCandidateProfile: async function(input, countryLanguage) {
    await Apollo.instance.defaultClient.mutate({
      mutation: UPDATE_CANDIDATE_PROFILE,
      variables: {
        input,
        countryLanguage
      }
    })
  },
  updateCandidateProfileTranslation: async function(input, countryLanguage) {
    await Apollo.instance.defaultClient.mutate({
      mutation: UPDATE_CANDIDATE_PROFILE_TRANSLATION,
      variables: {
        input,
        countryLanguage
      }
    })
  },
  deleteCandidateProfileTranslation: async function(input) {
    await Apollo.instance.defaultClient.mutate({
      mutation: DELETE_CANDIDATE_PROFILE_TRANSLATION,
      variables: {
        input
      }
    })
  }
}
